import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash/isEmpty'

const propTypes = {
    data: PropTypes.objectOf(PropTypes.string)
}

/**
 * A HOC to add data attributes to any component.
 *
 * @param {React.Component} Component
 * @return {Function} {addDataAttributes}
 */
function withDataAttributes(Component) {
    return function addDataAttributes(props) {
        addDataAttributes.propTypes = propTypes

        const { data, ...restProps } = props
        const dataAttributes = {}

        if (data && !isEmpty(data)) {
            Object.keys(data).forEach(dataKey => {
                dataAttributes[`data-${dataKey.toString().toLowerCase()}`] = data[dataKey]
            })
        }

        return <Component dataAttributes={dataAttributes} {...restProps} />
    }
}

export { withDataAttributes }
